/**
 * Styled Components - Created by eduardoquintero on 17/11/20.
 */
import styled from 'styled-components'
import Dropdown from 'antd/lib/dropdown'
import Menu from 'antd/lib/menu'
import { BLACK_SEMILIGHT, BLUE, GRAY, WHITE, GRAY_LIGHT, DARKER_GRAY, BLACK } from '../../../theme/colors'

interface ButtonProps {
  disabled?: boolean
  show?: boolean
  text?: string
  active?: boolean
}

export const MobileNavContainer = styled.div`
  padding: 10px;
  width: 100%;
  background-color: ${BLACK_SEMILIGHT};
  color: ${WHITE};
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
`

const Button = styled.div`
  padding: 10px;
  border-radius: 4px;
  background-color: ${({ disabled }: ButtonProps) =>
  disabled ? GRAY_LIGHT : BLUE};
  visibility: ${({ show }: ButtonProps) =>
  show ? 'visible' : 'hidden'};
`

const GrayButton = styled.div`
  padding: 10px;
  border-radius: 4px;
  color: ${({ disabled }: ButtonProps) =>
  disabled ? WHITE : BLACK};
  background-color: ${({ disabled }: ButtonProps) =>
  disabled ? GRAY_LIGHT : GRAY};
  visibility: ${({ show }: ButtonProps) =>
  show ? 'visible' : 'hidden'};
`

export const Previous = styled(GrayButton)`
  &::after {
    content: ${({ text }: ButtonProps) => `"${text}"`};
  }
`

export const ActionContainer = styled.div`
  position: fixed;
  bottom: 0;
  z-index: 1000;
  left: 0;  
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 10px;
  padding-inline: 16px;
`
export const SkipButton = styled.button`
  flex-shrink: 0;
  color: #625F5F;
  text-align: center;
  font-size: 14px;
  font-weight: 600;
  text-decoration-line: underline;
  border: none;
  background: none;
  margin-inline: 12px 20px;
`
  
export const Continue = styled(Button)`
  text-align: center;
  width: 100%;
  height: 40px;
  justify-content: center;
  border: none;
  display: flex;
  align-items: center;
  border-radius: 22px;
  font-size: 14px;
  color: #FFF;
  && {
    background: #302628;
    background-color: #302628;
  }
  &::after {
    content: ${({ text }: ButtonProps) => `"${text}"`};
  }
  &&.disabled {
    background: #D7D1D2;
    background-color: #D7D1D2;
    color: #625F5F;
  }
`

export const StyledDropdown = styled(Dropdown)`
  position: absolute;
  right: 0;
  left: 0;
  margin: 0 auto;
  text-align: center;
  max-width: 180px;
  color: ${WHITE};
`

export const StyledMenu = styled(Menu)`
  left: 0;
  right: 0;
  position: absolute;
  margin: 0 auto;
  max-width: 180px;
`

export const Image = styled.img`
  margin-left: 5px;
`

export const ItemText = styled.div`
  color: ${({ active }: ButtonProps) => active ? DARKER_GRAY : GRAY_LIGHT};
  &.selected{
    font-weight: 600;
  }
`

export const Logo = styled.img`
  align-self: center;
  height: 24px;
  width: 100%;
  left: 0;
  position: absolute;
  object-fit: contain;
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/screens/IntakeForm/MobileMenuNav/styledComponents.tsx